// src/features/sidebar/sidebarSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk to check dealer payment access
export const checkDealerPayment = createAsyncThunk(
  'sidebar/checkDealerPayment',
  async (customerId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://alcobrakeadmin.com/v3/us/cadealerpayments/checkdealerpaymentnew?customer_id=${customerId}`
      );
      return { grantAccess: !response.data.paymentdue };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Role-based sidebar categories - matches your Vue component exactly
// export const getSidebarCategories = (userRole, grantAccess = true, userState = null) => {
  export const getSidebarCategories = (
  userRole,
  grantAccess = true,
  userState = null,
  userEmail = ''
) => {
  // Import icons inside function to avoid circular dependencies
  const {
    LayoutDashboard, Users, UserSquare2, Building2, Wrench,
    Smartphone, Monitor, UserCog, FileText, Database, Trash2,
    Settings, CreditCard, PenTool, Map, Lock, BookOpen, Cpu,
    Shield, Truck, School, UsersRound, Calendar, Bell, Activity,
    FileSpreadsheet, ClipboardList, HardDrive, Cloud, Receipt, Download
  } = require('lucide-react');

  // Production account - show only Clients and Devices.
  if (String(userEmail).trim().toLowerCase() === 'alcobrakeproduction@gmail.com') {
  return [
    {
      title: 'MAIN',
      items: [
        {
          label: 'PRODUCTION DASHBOARD',
          icon: 'Monitor',
          path: '/production-dashboard',
          id: 'production-dashboard'
        },
        {
          label: 'CLIENTS',
          icon: 'UserSquare2',
          path: '/clients',
          id: 'clients'
        },
        {
          label: 'DEVICES',
          icon: 'Smartphone',
          path: '/devices',
          id: 'devices'
        },
        // {
        //   label: 'Tracking',
        //   icon: 'Database',
        //   path: '/production-devices',
        //   id: 'production-devices'
        // }
      ]
    }
  ];
}

  // ADMIN Role (matches your Vue component)
  if (userRole === "Admin") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'DASHBOARD', icon: 'LayoutDashboard', path: '/dashboard', id: 'dashboards' },
        ]
      },
      {
        title: 'OPERATIONS',
        items: [
          { label: 'DEALERS', icon: 'Users', path: '/dealers', id: 'dealers' },
          { label: 'OFFICERS', icon: 'Building2', path: '/offices', id: 'offices' },
          { label: 'TECHNICIAN', icon: 'Wrench', path: '/technician', id: 'technician' },
          { label: 'CLIENTS', icon: 'UserSquare2', path: '/clients', id: 'clients' },
          { label: 'APPOINTMENTS', icon: 'Calendar', path: '/appointments', id: 'appointments' },
          { label: 'ANNOUNCEMENT', icon: 'Megaphone', path: '/announcement', id: 'announcement' },
        ]
      },
      {
        title: 'HARDWARE',
        items: [
          { label: 'OLEDDEVICES', icon: 'Monitor', path: '/oleddevices', id: 'oleddevices' },
          { label: 'GEO-FENCING', icon: 'Map', path: '/geo-fencing', id: 'geo-fencing' },
          { label: 'DEVICES', icon: 'Smartphone', path: '/devices', id: 'devices' },
        ]
      },
      {
        title: 'SYSTEM',
        items: [
          { label: 'CLIENT_OFFICER', icon: 'UserCog', path: '/clientofficer', id: 'clientofficer' },
          { label: 'CALIBRATIONKIT', icon: 'PenTool', path: '/calibrationkit', id: 'calibrationkit' },
          { label: 'LOG FILES', icon: 'FileText', path: '/log_files', id: 'log_files' },
          { label: 'REPORTS', icon: 'FileText', path: '/reports', id: 'reports' },
          { label: 'REMOVALS', icon: 'Trash2', path: '/removals', id: 'removals' },
          { label: 'BACKUPS', icon: 'Database', path: '/backups', id: 'backups' },
          { label: 'GATEWAY', icon: 'Download', path: '/gateway', id: 'gateway' },
        ]
      },
      {
        title: 'MONITORING',
        items: [
          { label: 'INVOICE', icon: 'Receipt', path: '/invoice', id: 'invoice' },
          { label: 'PAYMENTMODE', icon: 'CreditCard', path: '/PaymentMode', id: 'PaymentMode' },
        ]
      }
    ];
  }

  // SUPERADMIN Role (matches your Vue component)
  if (userRole === "superadmin") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'DASHBOARD', icon: 'LayoutDashboard', path: '/dashboard', id: 'dashboards' },
        ]
      },
      {
        title: 'OPERATIONS',
        items: [
          { label: 'DEALERS', icon: 'Users', path: '/dealers', id: 'dealers' },
          { label: 'OFFICERS', icon: 'Building2', path: '/offices', id: 'offices' },
          { label: 'TECHNICIAN', icon: 'Wrench', path: '/technician', id: 'technician' },
          { label: 'CLIENTS', icon: 'UserSquare2', path: '/clients', id: 'clients' },
          { label: 'APPOINTMENTS', icon: 'Calendar', path: '/appointments', id: 'appointments' },
          { label: 'ANNOUNCEMENT', icon: 'Megaphone', path: '/announcement', id: 'announcement' },
        ]
      },
      {
        title: 'HARDWARE',
        items: [
          { label: 'OLEDDEVICES', icon: 'Monitor', path: '/oleddevices', id: 'oleddevices' },
          { label: 'DEVICES', icon: 'Smartphone', path: '/devices', id: 'devices' },
          { label: 'GEO-FENCING', icon: 'Map', path: '/geo-fencing', id: 'geo-fencing' },
        ]
      },
      {
        title: 'SYSTEM',
        items: [
          { label: 'CLIENT_OFFICER', icon: 'UserCog', path: '/clientofficer', id: 'clientofficer' },
          { label: 'CALIBRATIONKIT', icon: 'PenTool', path: '/calibrationkit', id: 'calibrationkit' },
          { label: 'FIRMWARES', icon: 'Cpu', path: '/firmwares', id: 'firmwares' },
          { label: 'REPORTS', icon: 'FileText', path: '/reports', id: 'reports' },
          { label: 'REMOVALS', icon: 'Trash2', path: '/removals', id: 'removals' },
          { label: 'PAYMENTS', icon: 'CreditCard', path: '/autopay', id: 'autopay' },
          // { label: 'LOCKOUT STATUS', icon: 'Lock', path: '/lockoutstatus', id: 'lockoutstatus' },
          { label: 'MANAGEMENT', icon: 'Settings', path: '/management', id: 'management' },
        ]
      }
    ];
  }

  // DEALER Role with Grant Access and not INDIA
  if (userRole === "dealer" && grantAccess && userState !== "INDIA") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'DASHBOARD', icon: 'LayoutDashboard', path: '/dashboard', id: 'dashboards' },
        ]
      },
      {
        title: 'OPERATIONS',
        items: [
          { label: 'OFFICERS', icon: 'Building2', path: '/offices', id: 'offices' },
          { label: 'TECHNICIAN', icon: 'Wrench', path: '/technician', id: 'technician' },
          { label: 'CLIENTS', icon: 'UserSquare2', path: '/clients', id: 'clients' },
          { label: 'APPOINTMENTS', icon: 'Calendar', path: '/appointments', id: 'appointments' },
          { label: 'ANNOUNCEMENT', icon: 'Megaphone', path: '/announcement', id: 'announcement' },
        ]
      },
      {
        title: 'HARDWARE',
        items: [
          { label: 'DEVICES', icon: 'Smartphone', path: '/devices', id: 'devices' },
        ]
      },
      {
        title: 'SYSTEM',
        items: [
          { label: 'CLIENT_OFFICER', icon: 'UserCog', path: '/clientofficer', id: 'clientofficer' },
          { label: 'PAYMENTS', icon: 'CreditCard', path: '/autopay', id: 'autopay' },
          { label: 'REPORTS', icon: 'FileText', path: '/reports', id: 'reports' },
          { label: 'REMOVALS', icon: 'Trash2', path: '/removals', id: 'removals' },
        ]
      }
    ];
  }

  // DEALER Role with INDIA state
  if (userRole === "dealer" && userState === "INDIA") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'DASHBOARD', icon: 'LayoutDashboard', path: '/dashboard', id: 'dashboards' },
        ]
      },
      {
        title: 'OPERATIONS',
        items: [
          { label: 'OFFICERS', icon: 'Building2', path: '/offices', id: 'offices' },
          { label: 'TECHNICIAN', icon: 'Wrench', path: '/technician', id: 'technician' },
          { label: 'CLIENTS', icon: 'UserSquare2', path: '/clients', id: 'clients' },
          { label: 'APPOINTMENTS', icon: 'Calendar', path: '/appointments', id: 'appointments' },
          { label: 'ANNOUNCEMENT', icon: 'Megaphone', path: '/announcement', id: 'announcement' },
        ]
      },
      {
        title: 'HARDWARE',
        items: [
          { label: 'DEVICES', icon: 'Smartphone', path: '/devices', id: 'devices' },
          { label: 'GEO-FENCING', icon: 'Map', path: '/geo-fencing', id: 'geo-fencing' },
        ]
      },
      {
        title: 'SYSTEM',
        items: [
          { label: 'CLIENT_OFFICER', icon: 'UserCog', path: '/clientofficer', id: 'clientofficer' },
          { label: 'PAYMENTS', icon: 'CreditCard', path: '/autopay', id: 'autopay' },
          { label: 'REPORTS', icon: 'FileText', path: '/reports', id: 'reports' },
          { label: 'REMOVALS', icon: 'Trash2', path: '/removals', id: 'removals' },
        ]
      }
    ];
  }

  // DEALER Role without Grant Access
  if (userRole === "dealer" && !grantAccess) {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'DASHBOARD', icon: 'LayoutDashboard', path: '/dashboard', id: 'dashboards' },
        ]
      }
    ];
  }

  // OFFICE Role
  if (userRole === "office") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'CLIENTS', icon: 'BookOpen', path: '/office_logs', id: 'office_logs' },
        ]
      }
    ];
  }

  // NEOWAY Role
  if (userRole === "neoway") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'GPSDASHBOARD', icon: 'LayoutDashboard', path: '/gpsdashboard', id: 'gpsdashboard' },
          { label: 'REPORTS', icon: 'FileText', path: '/fleetreports', id: 'fleetreports' },
        ]
      }
    ];
  }

  // UPLOADER Role
  if (userRole === "uploader") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'FILE-TRANSLATOR', icon: 'Download', path: '/filetranslator', id: 'filetranslator' },
        ]
      }
    ];
  }

  // SCHOOL Role
  if (userRole === "school") {
    return [
      {
        title: 'MAIN',
        items: [
          { label: 'DASHBOARD', icon: 'LayoutDashboard', path: '/dashboard', id: 'dashboards' },
        ]
      },
      {
        title: 'OPERATIONS',
        items: [
          { label: 'DEPARTMENTS', icon: 'Building2', path: '/offices', id: 'offices' },
          { label: 'VEHICLES', icon: 'Truck', path: '/clients', id: 'clients' },
          { label: 'ROUTES', icon: 'Map', path: '/routes', id: 'routes' },
          { label: 'TECHNICIAN', icon: 'Wrench', path: '/technician', id: 'technician' },
          { label: 'TEACHERS', icon: 'UsersRound', path: '/teachers', id: 'teachers' },
          { label: 'STUDENTS', icon: 'School', path: '/students', id: 'students' },
        ]
      },
      {
        title: 'SYSTEM',
        items: [
          { label: 'SERVICES', icon: 'Settings', path: '/services', id: 'services' },
        ]
      }
    ];
  }

  // Default/Unknown role
  return [
    {
      title: 'MAIN',
      items: [
        { label: 'DASHBOARD', icon: 'LayoutDashboard', path: '/dashboard', id: 'dashboards' },
        { label: 'CLIENTS', icon: 'UserSquare2', path: '/clients', id: 'clients' },
      ]
    }
  ];
};

const initialState = {
  sidebarCategories: [],
  grantAccess: true,
  loading: false,
  error: null,
  isCollapsed: false,
  isMobileOpen: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarCategories: (state, action) => {
      state.sidebarCategories = action.payload;
    },
    setGrantAccess: (state, action) => {
      state.grantAccess = action.payload;
    },
    toggleCollapse: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    setCollapsed: (state, action) => {
      state.isCollapsed = action.payload;
    },
    setMobileOpen: (state, action) => {
      state.isMobileOpen = action.payload;
    },
    toggleMobileOpen: (state) => {
      state.isMobileOpen = !state.isMobileOpen;
    },
    clearSidebar: (state) => {
      state.sidebarCategories = [];
      state.grantAccess = true;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkDealerPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkDealerPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.grantAccess = action.payload.grantAccess;
      })
      .addCase(checkDealerPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.grantAccess = true;
      });
  },
});

export const {
  setSidebarCategories,
  setGrantAccess,
  toggleCollapse,
  setCollapsed,
  setMobileOpen,
  toggleMobileOpen,
  clearSidebar,
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
